import { useCallback } from 'react';
import { openInNewTab } from '#shared/lib/router';
import { constructorRoute } from '#shared/lib/routes';
import { useGetConstructorPageTemplates } from '../../api';
import { ConstructorPageTemplateSelectUI } from './ConstructorPageTemplateSelectUI';
import { type ConstructorPageTemplateSelectProps } from './types';

export const ConstructorPageTemplateSelect = (props: ConstructorPageTemplateSelectProps) => {
    const { data: templates } = useGetConstructorPageTemplates({ page_alias: props.alias });

    const openConstructor = useCallback(() => {
        if (!props.value) {
            return;
        }

        openInNewTab(
            constructorRoute.getUrl({
                searchParams: {
                    tab: 'sections',
                    page: props.value,
                },
            })
        );
    }, [props.value]);

    return <ConstructorPageTemplateSelectUI templates={templates} openConstructor={openConstructor} {...props} />;
};
